/* global store */
/* global REPEAT_VIEW */

import { IN_VIEW_PERCENTAGE } from 'Tracking/constants/index';
import { startAd, visibilityChanged } from 'Renderer/actions/adActions';
import { adMovedIntoView, adMovedOutOfView } from 'Tracking/actions/ad';
import { initCarouselEvents, clearCarouselEvents } from 'Renderer/utils/smartGroupScript';
import { renderArtboard } from 'Renderer/domOperations/artboardOperations';
import { setTargetComponentTimeline } from 'Renderer/domOperations/animationOperations';
import { isVisible } from 'Renderer/domOperations/actionOperations';
import { syncTimeline } from 'Renderer/domOperations/syncOperations';
import getVisiblePercentage from 'Render/utils/getVisiblePercentage';
import { fireTracking } from 'Tracking/index';
import { AD_STARTED } from 'Tracking/constants/events';
import {
  AUTO_PLAY_VIDEO_CLASS,
  SYNC_VIDEO_CLASS,
} from 'Tracking/constants/selectors';

const setDefaultComponentStates = () => {
  const { rootElement } = store.getState();
  [...rootElement.querySelectorAll(`.${AUTO_PLAY_VIDEO_CLASS}`)].forEach((v) => {
    const videoContainer = v.parentNode;
    const isInCarousel = videoContainer.closest('[data-behaviour=carousel]');
    const videoVisible = isInCarousel ? isVisible(videoContainer) : videoContainer.visibility !== 'hidden';
    const isiOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform); // eslint-disable-line no-undef
    if (videoVisible) {
      if (v.readyState !== 4 && !isiOS) v.oncanplay = () => v.play();
      else v.play();
    }
  });
};

export const isAdInView = () => {
  const { visiblePercentage } = store.getState();
  return visiblePercentage >= IN_VIEW_PERCENTAGE;
};

export const maybeStartAd = (artboard) => {
  const {
    timelines,
    activeArtboard,
    hasStarted,
    rootElement,
    skins,
    wallpaper,
  } = store.getState();
  const selectedArboard = (typeof artboard !== 'undefined') ? artboard : activeArtboard;

  if (typeof selectedArboard === 'undefined') return;

  const timeline = timelines[selectedArboard.key];

  if (!hasStarted && (skins || wallpaper)) initCarouselEvents(rootElement);

  if ((!isAdInView() || hasStarted) && !skins && !wallpaper) return;
  setDefaultComponentStates();
  initCarouselEvents(rootElement);

  const syncElements = rootElement.querySelectorAll(`.${SYNC_VIDEO_CLASS}`);

  [...syncElements].map(v => syncTimeline(v));

  if (!syncElements.length) {
    timeline.play(0);
    const groupElements = rootElement.querySelectorAll('div[data-group]:not([data-autohide="true"])');
    [...groupElements].forEach((elem) => {
      const componentTimeline = setTargetComponentTimeline(elem, activeArtboard);
      if (componentTimeline) componentTimeline.play(0);
    });
  }

  startAd();
  fireTracking(AD_STARTED);
};

const hasAdMoved = (visiblePercentage) => {
  const { visiblePercentage: currentVisiblePercentage } = store.getState();
  return (visiblePercentage !== currentVisiblePercentage);
};

const hasAdMovedIntoView = () => {
  const { visiblePercentage, lastVisiblePercentage } = store.getState();
  return (visiblePercentage >= IN_VIEW_PERCENTAGE && lastVisiblePercentage < IN_VIEW_PERCENTAGE);
};

const hadAdMovedOutOfView = () => {
  const { visiblePercentage, lastVisiblePercentage } = store.getState();
  return (visiblePercentage < IN_VIEW_PERCENTAGE && lastVisiblePercentage >= IN_VIEW_PERCENTAGE);
};

const hadAdMovedOutOfViewport = () => {
  const { visiblePercentage, lastVisiblePercentage } = store.getState();
  return (visiblePercentage === 0 && lastVisiblePercentage > 0);
};

const restartTimelineVideos = () => {
  const { timeline, rootElement, rootDocument } = store.getState();
  timeline.play();
  [...rootElement.querySelectorAll(`.${AUTO_PLAY_VIDEO_CLASS}`)].forEach((e) => {
    const rootWindow = rootDocument.parentWindow || rootDocument.defaultView;
    if (rootWindow.getComputedStyle(e).visibility === 'visible') e.play();
  });
};

const pauseTimelineVideos = () => {
  const { timeline, rootElement } = store.getState();
  [...rootElement.querySelectorAll(`.${AUTO_PLAY_VIDEO_CLASS}`)].forEach(e => e.pause());
  timeline.pause();
};

export const updateVisibility = (visiblePercentage) => {
  const { hasStarted } = store.getState();

  if (!hasAdMoved(visiblePercentage)) return;

  visibilityChanged(visiblePercentage);

  if (hasAdMovedIntoView()) {
    adMovedIntoView();
    if (hasStarted && (REPEAT_VIEW === 'resume')) restartTimelineVideos();
    else maybeStartAd();
  } else if (hadAdMovedOutOfView()) {
    adMovedOutOfView();
    if (hasStarted) clearCarouselEvents();
    if (hasStarted && (REPEAT_VIEW === 'resume')) pauseTimelineVideos();
  } else if (hadAdMovedOutOfViewport()) {
    if (REPEAT_VIEW === 'resume') pauseTimelineVideos();
    else renderArtboard();
  }
};

export const visibilityChangeEvent = () => {
  const visiblePercentage = getVisiblePercentage();
  updateVisibility(visiblePercentage);
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/adOperations.js